<template>
	<div class="item_sidebar">
		<div class="wrapper_input">
			<CodePopup :insert-code="true" :html="value" v-if="open" @close="open=false" @done="save"/>

			<v-button border @click="open=true" :label="title"></v-button>
		</div>
	</div>
</template>

<script>
import {mapGetters} from "vuex"
import VButton from '@/components/base/v-button';
import CodePopup from "@/modules/page-editor/src/components/popups/CodePopup";

export default {
	name: 'CustomCodeButton',
	props: ["value", "title"],
	components: {CodePopup, VButton},
	data() {
		return {
			open: false,
		}
	},
	computed: {
		...mapGetters(['page_id', 'page_findOne']),
		content() {
			let el = this.page_findOne(this.page_id);
			return this.value;
		}
	},
	methods: {
		save(html,css,bodyjs,headjs) {
			this.open = false;
			this.$emit('updated', html);

			console.log("save", html, css)
		},
	},
}
</script>
